// extracted by mini-css-extract-plugin
export var columnList = "_dr-0";